import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { ApiUtils, EventBusUtils, HumpUtils, StorageUtils, SystemUtils } from "utils";
import { ApiConstant, AppConstant, KeyConstant, LangConstant, SystemConstant } from "const";
import useInvalidateQueries from "hooks/common/useInvalidateQueries";
import qs from "qs";

export default function useEditDepartment() {
  const { t: getLabel } = useTranslation();

  const { invalidateUnitQueries, invalidateDepartmentQueries } = useInvalidateQueries();

  const editDepartmentMutation = useMutation({
    mutationFn: async data => {
      const branchId = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_ID);
      const payload = {
        branchId,
        unitId: data.unitId,
        departmentId: data.departmentId,
        departmentName: data.departmentName,
      };
      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.POST_UPDATE_DEPARTMENT,
        qs.stringify(HumpUtils.decamelizeKeys(payload)),
      );
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { unitId, onClose }) => {
      if (response.status === ApiConstant.STT_OK) {
        await invalidateUnitQueries();
        await invalidateDepartmentQueries();
        await ApiUtils.apiCreateUserActivitiesLog(SystemConstant.LOGGER_ACTION_TYPES.EDIT_DEPARTMENT);
        EventBusUtils.emit(AppConstant.EVENT_BUS_EVENTS.refetchDepartments, unitId);
        SystemUtils.appendNotification(getLabel("TXT_UPDATE_DEPARTMENT_SUCCESS"), "success");
        onClose();
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.DEPARTMENT_ERROR.MISSING_PARAMETERS
      ) {
        SystemUtils.appendNotification(getLabel("TXT_MISSING_FORM_PARAMS"), "error");
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.DEPARTMENT_ERROR.IN_WRONG_FORMAT
      ) {
        SystemUtils.appendNotification(getLabel("TXT_INVALID_DEPARTMENT_NAME"), "error");
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.DEPARTMENT_ERROR.DUPLICATED
      ) {
        SystemUtils.appendNotification(getLabel("TXT_DEPARTMENT_DUPLICATED"), "error");
      } else {
        SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const editDepartment = payload => {
    editDepartmentMutation.mutate(payload);
  };

  return { editDepartment };
}
